module.exports = __webpack_public_path__ + "img/ResourceFood_ua.586c4d49.webp";